module.exports = __webpack_public_path__ + "static/pattern-widget-rulebuilder-efec1d3c1f4973a3c1e2135d29fdd979.png";